export function DescendingTextSortIcon() {
  return (
    <svg
      data-slot='descending-text-sort-icon'
      className='size-[1lh] shrink-0'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      aria-hidden='true'
      focusable='false'
    >
      <g transform='translate(0 24) scale(0.025 -0.025)' fill='currentColor'>
        <path
          transform='translate(400)'
          d='M196 376 173 306Q169 295 159 287.5Q149 280 137 280Q117 280 104.5 296.5Q92 313 100 333L220 654Q225 666 235 673Q245 680 258 680H288Q301 680 311 673Q321 666 326 654L447 331Q454 312 442.5 296Q431 280 411 280Q399 280 389 287.5Q379 295 375 306L350 376ZM220 444H324L276 594H270Z'
        />
        <path
          transform='translate(-400)'
          d='M638 352H804Q819 352 829.5 341.5Q840 331 840 316Q840 301 829.5 290.5Q819 280 804 280H572Q562 280 555 287Q548 294 548 304V342Q548 349 550 355.5Q552 362 557 367L750 608H592Q577 608 566.5 618.5Q556 629 556 644Q556 659 566.5 669.5Q577 680 592 680H814Q824 680 831 673Q838 666 838 656V618Q838 611 836 604.5Q834 598 829 593Z'
        />
        <path d='M384 760Q377 760 374.5 766Q372 772 377 777L466 866Q472 872 480 872Q488 872 494 866L583 777Q588 772 585.5 766Q583 760 576 760ZM466 94 377 183Q372 188 374.5 194Q377 200 384 200H576Q583 200 585.5 194Q588 188 583 183L494 94Q488 88 480 88Q472 88 466 94Z' />
      </g>
    </svg>
  )
}
